import { InfoIcon, ExternalLinkIcon } from "lucide-react";
import { Button } from "@heroui/react";

interface TwitterLinkNoticeProps {
  onConnect: (redirectUrl: string) => void;
}

export const TwitterLinkNotice = ({ onConnect }: TwitterLinkNoticeProps) => (
  <div className="bg-[#0C1113] border border-gray-800/50 rounded-xl p-4 shadow-sm">
    <div className="flex items-start gap-3">
      <InfoIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-0.5" />
      <div className="space-y-3">
        <div className="space-y-1.5">
          <h3 className="font-medium text-white">Connect your X account</h3>
          <p className="text-sm text-gray-400">
            To complete X-related tasks, you need to connect your X (Twitter)
            account first. This helps us verify your social actions.
          </p>
        </div>

        <div className="flex items-center gap-2">
          <Button
            size="sm"
            onPress={() => onConnect(window.location.href)}
            className="bg-[#60FF8A] text-black font-semibold px-4 py-2 rounded-lg hover:bg-[#60FF8A]/90 transition-colors flex items-center justify-center"
          >
            Connect X Account
          </Button>
        </div>
      </div>
    </div>
  </div>
);
